import { SuperTaskModel } from "../../Models/API/SuperTaskModel"
import { MainThunkDispatch, State } from "../../Reducers"
import { apiEndpoints } from "../../Routes/api"
import { failMessage, successMessage } from "../Client/MessagesActions"
import { apiFetch } from "../Client/NetworkActions"
import { SuperTasksAppType } from "../Types"

export const getSuperTasks =
    (appID: string) =>
    async (dispatch: MainThunkDispatch, getState: () => State) => {
        try {
            const isLoading = getState().api.superTasks[appID]?.isLoading
            if (!isLoading) {
                dispatch({
                    type: SuperTasksAppType.listRequest,
                    payload: {
                        appID
                    }
                })
                const endpoint = apiEndpoints.getSuperTasks({
                    appID
                })
                const data = await dispatch(
                    apiFetch<{ superTasks: SuperTaskModel[] }>(
                        endpoint.url,
                        endpoint
                    )
                )

                dispatch({
                    type: SuperTasksAppType.setList,
                    payload: {
                        appID,
                        list: data !== undefined ? data.superTasks : []
                    }
                })
            }
        } catch (error) {
            dispatch(failMessage("Could not get super tasks", error))
            dispatch({
                type: SuperTasksAppType.setListError,
                payload: {
                    appID,
                    error: "Could not get super tasks"
                }
            })
            throw error
        }
    }

export const updateSuperTasks =
    ({
        appID,
        superTasks,
        cancelAndRelabelJobsInState
    }: {
        appID: string
        superTasks: SuperTaskModel[]
        cancelAndRelabelJobsInState: string[]
    }) =>
    async (dispatch: MainThunkDispatch, getState: () => State) => {
        try {
            const endpoint = apiEndpoints.getSuperTasks({
                appID
            })
            const data = await dispatch(
                apiFetch(endpoint.url, endpoint, {
                    method: "PATCH",
                    body: JSON.stringify({
                        superTasks,
                        cancelAndRelabelJobsInState
                    })
                })
            )

            if (data === undefined) {
                return
            }

            dispatch(successMessage("Super tasks are updated"))
            dispatch({
                type: SuperTasksAppType.setList,
                payload: {
                    appID,
                    list: data.superTasks
                }
            })
        } catch (error) {
            dispatch(failMessage("Could not update super tasks", error))
            throw error
        }
    }
